import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ButtonBase } from '../ButtonBase';
import { getIconClasses } from '../IconClasses';
export const IconButton = React.forwardRef((t0, ref) => {
  const $ = _c(13);
  let Icon;
  let props;
  let shape;
  let t1;
  if ($[0] !== t0) {
    ({
      icon: Icon,
      ...props
    } = t0);
    const {
      color,
      variant,
      size,
      shape: t2
    } = props;
    shape = t2 === undefined ? "rounded" : t2;
    t1 = getIconClasses({
      color,
      variant,
      size
    });
    $[0] = t0;
    $[1] = Icon;
    $[2] = props;
    $[3] = shape;
    $[4] = t1;
  } else {
    Icon = $[1];
    props = $[2];
    shape = $[3];
    t1 = $[4];
  }
  const {
    iconClasses
  } = t1;
  let t2;
  if ($[5] !== Icon || $[6] !== iconClasses) {
    t2 = <Icon data-testid="icon" className={iconClasses} />;
    $[5] = Icon;
    $[6] = iconClasses;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== ref || $[10] !== shape || $[11] !== t2) {
    t3 = <ButtonBase shape={shape} {...props} ref={ref}>{t2}</ButtonBase>;
    $[8] = props;
    $[9] = ref;
    $[10] = shape;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
});
IconButton.displayName = 'IconButton';